import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { UserProvider } from '../../providers/user';
import { TeamappProvider } from '../../providers/teamapp';
/**
 * Generated class for the IdcardPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-idcard',
  templateUrl: 'idcard.html',
})
export class IdcardPage {

  title: string = 'Mitarbeiterausweis';
  qrData: string = '';
  userType: string = 'member';
  constructor(public userProvider: UserProvider, public teamappProvider: TeamappProvider , public navCtrl: NavController, public navParams: NavParams) {
      if(this.navParams.get("title")) {
          this.title = this.navParams.get("title");
      }
      this.loadIdCard();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad IdcardPage');
  }

  loadIdCard() {
      this.teamappProvider.http_request('', 'idcard', false, true).then(data => {
          let response: any = data;

          this.qrData = response.code;
          this.userType = response.user_type;
      });
  }

}



// WEBPACK FOOTER //
// ./src/pages/idcard/idcard.ts